(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (function() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    var backdrop = document.querySelector('[data-cart-drawer-backdrop]');
    var closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    var sectionId = drawer.getAttribute('data-section-id');

    function openDrawer() {
      drawer.classList.add('cart-drawer--active');
      backdrop.classList.add('cart-drawer__backdrop--active');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('cart-drawer--active');
      backdrop.classList.remove('cart-drawer__backdrop--active');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      document.body.style.overflow = '';
    }

    /* Listen for custom event from header cart button */
    document.addEventListener('cart-drawer:open', function() {
      openDrawer();
    });

    /* Close on close button click */
    if (closeBtn) {
      closeBtn.addEventListener('click', closeDrawer);
    }

    /* Close on backdrop click */
    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    /* Close on Escape key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('cart-drawer--active')) {
        closeDrawer();
      }
    });

    /* Re-render cart drawer with section rendering API */
    function refreshCart() {
      drawer.classList.add('cart-drawer--loading');

      fetch('/?sections=' + sectionId)
        .then(function(response) { return response.json(); })
        .then(function(data) {
          var html = data[sectionId];
          var tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;

          var newContent = tempDiv.querySelector('[data-cart-drawer-content]');
          var currentContent = drawer.querySelector('[data-cart-drawer-content]');

          if (newContent && currentContent) {
            currentContent.innerHTML = newContent.innerHTML;
          }

          /* Update header cart count */
          updateCartCount();
        })
        .catch(function(err) {
          console.error('Failed to refresh cart:', err);
        })
        .finally(function() {
          drawer.classList.remove('cart-drawer--loading');
        });
    }

    /* Fetch cart data to update header badge */
    function updateCartCount() {
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          var countBadges = document.querySelectorAll('[data-cart-count]');
          countBadges.forEach(function(badge) {
            if (cart.item_count > 0) {
              badge.textContent = cart.item_count;
              badge.style.display = '';
            } else {
              badge.textContent = '';
              badge.style.display = 'none';
            }
          });
        });
    }

    /* Change item quantity */
    function changeQuantity(line, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      })
        .then(function(response) { return response.json(); })
        .then(function() {
          refreshCart();
        })
        .catch(function(err) {
          console.error('Failed to update cart:', err);
        });
    }

    /* Event delegation for quantity buttons and remove buttons */
    drawer.addEventListener('click', function(e) {
      var target = e.target.closest('[data-quantity-minus], [data-quantity-plus], [data-remove-item], [data-discount-apply]');
      if (!target) return;

      /* Quantity minus */
      if (target.hasAttribute('data-quantity-minus')) {
        var line = parseInt(target.getAttribute('data-line'), 10);
        var quantity = parseInt(target.getAttribute('data-quantity'), 10);
        changeQuantity(line, Math.max(0, quantity));
        return;
      }

      /* Quantity plus */
      if (target.hasAttribute('data-quantity-plus')) {
        var line = parseInt(target.getAttribute('data-line'), 10);
        var quantity = parseInt(target.getAttribute('data-quantity'), 10);
        changeQuantity(line, quantity);
        return;
      }

      /* Remove item */
      if (target.hasAttribute('data-remove-item')) {
        var line = parseInt(target.getAttribute('data-line'), 10);
        changeQuantity(line, 0);
        return;
      }

      /* Discount apply */
      if (target.hasAttribute('data-discount-apply')) {
        var input = drawer.querySelector('[data-discount-input]');
        if (input && input.value.trim()) {
          var code = input.value.trim();
          window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
        }
        return;
      }
    });

    /* Also listen for cart-drawer:refresh to allow other components to trigger a refresh */
    document.addEventListener('cart-drawer:refresh', function() {
      refreshCart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    /* Sticky header shrink on scroll */
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var scrollThreshold = 100;

    function onScroll() {
      if (window.scrollY > scrollThreshold) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    /* Mobile drawer toggle */
    var drawerToggle = header.querySelector('[data-drawer-toggle]');
    var drawerClose = header.querySelector('[data-drawer-close]');
    var drawer = header.querySelector('[data-header-drawer]');
    var backdrop = header.querySelector('[data-drawer-backdrop]');

    function openDrawer() {
      drawer.classList.add('header__drawer--active');
      backdrop.classList.add('header__drawer-backdrop--active');
      drawer.setAttribute('aria-hidden', 'false');
      drawer.removeAttribute('inert');
      drawerToggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('header__drawer--active');
      backdrop.classList.remove('header__drawer-backdrop--active');
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      drawerToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (drawerToggle) {
      drawerToggle.addEventListener('click', function() {
        var isOpen = drawer.classList.contains('header__drawer--active');
        if (isOpen) {
          closeDrawer();
        } else {
          openDrawer();
        }
      });
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    /* Cart button dispatches custom event */
    var cartToggle = header.querySelector('[data-cart-toggle]');
    if (cartToggle) {
      cartToggle.addEventListener('click', function() {
        document.dispatchEvent(new CustomEvent('cart-drawer:open'));
      });
    }

    /* Search button dispatches custom event */
    var searchToggle = header.querySelector('[data-search-toggle]');
    if (searchToggle) {
      searchToggle.addEventListener('click', function() {
        document.dispatchEvent(new CustomEvent('predictive-search:open'));
      });
    }

    /* Close drawer on Escape key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('header__drawer--active')) {
        closeDrawer();
        drawerToggle.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initCarousel(root) {
      const track = root.querySelector('[data-image-carousel-track]');
      if (!track || track.dataset.ready === 'true') return;
      const viewport = root.querySelector('.image-carousel__viewport');
      const prevBtn = root.querySelector('[data-image-carousel-prev]');
      const nextBtn = root.querySelector('[data-image-carousel-next]');
      const dots = Array.prototype.slice.call(root.querySelectorAll('[data-image-carousel-dot]'));

      const reals = Array.prototype.slice.call(track.children);
      const n = reals.length;
      if (n === 0) return;
      track.dataset.ready = 'true';

      const autoplay = root.dataset.autoplay === 'true';
      const speed = (parseInt(root.dataset.speed, 10) || 5) * 1000;

      let offset = 0;
      if (n > 1) {
        const head = document.createDocumentFragment();
        const tail = document.createDocumentFragment();
        reals.forEach(function(slide) {
          const after = slide.cloneNode(true);
          after.setAttribute('aria-hidden', 'true');
          tail.appendChild(after);
          const before = slide.cloneNode(true);
          before.setAttribute('aria-hidden', 'true');
          head.appendChild(before);
        });
        track.appendChild(tail);
        track.insertBefore(head, track.firstChild);
        offset = n;
      }

      const slides = Array.prototype.slice.call(track.children);
      let pos = offset;
      let logical = 0;
      let visible = false;
      const POSTER_WINDOW = 2;

      function step() {
        const cs = getComputedStyle(track);
        const gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
        return slides[0].getBoundingClientRect().width + gap;
      }

      function place(animate) {
        const vw = viewport.getBoundingClientRect().width;
        const sw = slides[pos].getBoundingClientRect().width;
        const x = (vw - sw) / 2 - pos * step();
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + x + 'px)';
        if (!animate) {
          void track.offsetWidth;
          track.style.transition = '';
        }
        slides.forEach(function(slide, i) {
          slide.classList.toggle('is-active', i === pos);
        });
        dots.forEach(function(dot, i) {
          dot.classList.toggle('image-carousel__dot--active', i === logical);
        });
        syncMedia();
      }

      function syncMedia() {
        slides.forEach(function(slide, i) {
          const video = slide.querySelector('video');
          if (!video) return;
          if (visible && video.dataset.poster && !video.poster && Math.abs(i - pos) <= POSTER_WINDOW) {
            video.poster = video.dataset.poster;
          }
          if (visible && i === pos) {
            video.muted = true;
            const playback = video.play();
            if (playback && playback.catch) playback.catch(function() {});
          } else {
            video.pause();
          }
        });
      }

      function move(dir) {
        if (n === 1) return;
        pos += dir;
        logical = (logical + dir + n) % n;
        place(true);
      }

      track.addEventListener('transitionend', function(e) {
        if (e.target !== track || e.propertyName !== 'transform') return;
        if (pos >= offset + n) {
          pos -= n;
          place(false);
        } else if (pos < offset) {
          pos += n;
          place(false);
        }
      });

      let timer = null;
      function start() {
        if (autoplay && n > 1 && !timer && visible) {
          timer = setInterval(function() { move(1); }, speed);
        }
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
      }

      if (nextBtn) nextBtn.addEventListener('click', function() { stop(); move(1); start(); });
      if (prevBtn) prevBtn.addEventListener('click', function() { stop(); move(-1); start(); });
      dots.forEach(function(dot, i) {
        dot.addEventListener('click', function() {
          stop();
          pos += (i - logical);
          logical = i;
          place(true);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);

      let resizeTimer;
      window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() { place(false); }, 150);
      });

      requestAnimationFrame(function() {
        place(false);
      });

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              visible = true;
              syncMedia();
              start();
            } else {
              visible = false;
              stop();
              syncMedia();
            }
          });
        }, { rootMargin: '300px 0px', threshold: 0.01 });
        io.observe(root);
      } else {
        visible = true;
        syncMedia();
        start();
      }
    }

    document.querySelectorAll('[data-image-carousel]').forEach(initCarousel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  (function() {
    var container = document.querySelector('[data-predictive-search]');
    if (!container) return;

    var form = container.querySelector('[data-predictive-search-form]');
    var input = container.querySelector('[data-predictive-search-input]');
    var resultsContainer = container.querySelector('[data-predictive-search-results]');
    var noResultsContainer = container.querySelector('[data-predictive-search-no-results]');
    var closeBtn = container.querySelector('[data-predictive-search-close]');
    var backdrop = document.querySelector('[data-predictive-search-backdrop]');

    var searchUrl = form ? form.getAttribute('data-url') : '';
    var debounceTimer = null;
    var currentQuery = '';
    var focusedIndex = -1;
    var resultLinks = [];

    /* Translations stored as data attributes aren't available, so use fallbacks */
    var PRODUCTS_HEADING = 'Products';
    var ARTICLES_HEADING = 'Articles';
    var VIEW_ALL_TEXT = 'View all results';
    var NO_RESULTS_TEXT = 'No results found';

    function open() {
      container.classList.add('predictive-search--active');
      container.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('predictive-search__backdrop--active');
      input.focus();
    }

    function close() {
      container.classList.remove('predictive-search--active');
      container.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('predictive-search__backdrop--active');
      input.value = '';
      currentQuery = '';
      focusedIndex = -1;
      resultLinks = [];
      hideResults();
    }

    function showResults() {
      resultsContainer.hidden = false;
      noResultsContainer.hidden = true;
    }

    function showNoResults() {
      resultsContainer.hidden = true;
      noResultsContainer.hidden = false;
    }

    function hideResults() {
      resultsContainer.hidden = true;
      noResultsContainer.hidden = true;
      resultsContainer.innerHTML = '';
    }

    function debounce(fn, delay) {
      return function() {
        var args = arguments;
        var context = this;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          fn.apply(context, args);
        }, delay);
      };
    }

    function fetchResults(query) {
      if (!query || query.length < 1) {
        hideResults();
        return;
      }

      var url = searchUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product,article&resources[limit]=6';

      fetch(url, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function(response) { return response.json(); })
        .then(function(data) {
          /* Only render if query hasn't changed while fetching */
          if (query !== currentQuery) return;

          var results = data.resources && data.resources.results;
          if (!results) {
            showNoResults();
            return;
          }

          var products = results.products || [];
          var articles = results.articles || [];

          /* Limit products to 4 and articles to 2 */
          products = products.slice(0, 4);
          articles = articles.slice(0, 2);

          if (products.length === 0 && articles.length === 0) {
            showNoResults();
            return;
          }

          renderResults(products, articles, query);
          showResults();
        })
        .catch(function(err) {
          console.error('Predictive search error:', err);
          hideResults();
        });
    }

    function renderResults(products, articles, query) {
      var html = '';

      if (products.length > 0) {
        html += '<div class="predictive-search__result-group">';
        html += '<h3 class="predictive-search__result-heading">' + PRODUCTS_HEADING + '</h3>';
        html += '<ul class="predictive-search__result-list" role="listbox">';
        products.forEach(function(product) {
          html += '<li class="predictive-search__result-item" role="option">';
          html += '<a href="' + product.url + '" class="predictive-search__result-link" data-predictive-search-link>';
          if (product.image) {
            html += '<img class="predictive-search__result-thumbnail" src="' + product.image + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="48" height="48">';
          } else {
            html += '<div class="predictive-search__result-thumbnail-placeholder"></div>';
          }
          html += '<div class="predictive-search__result-details">';
          html += '<p class="predictive-search__result-title">' + escapeHtml(product.title) + '</p>';
          if (product.price) {
            html += '<p class="predictive-search__result-price">' + product.price + '</p>';
          }
          html += '</div>';
          html += '</a>';
          html += '</li>';
        });
        html += '</ul>';
        html += '</div>';
      }

      if (articles.length > 0) {
        html += '<div class="predictive-search__result-group">';
        html += '<h3 class="predictive-search__result-heading">' + ARTICLES_HEADING + '</h3>';
        html += '<ul class="predictive-search__result-list" role="listbox">';
        articles.forEach(function(article) {
          html += '<li class="predictive-search__result-item" role="option">';
          html += '<a href="' + article.url + '" class="predictive-search__result-link" data-predictive-search-link>';
          if (article.image) {
            html += '<img class="predictive-search__result-thumbnail" src="' + article.image + '" alt="' + escapeHtml(article.title) + '" loading="lazy" width="48" height="48">';
          } else {
            html += '<div class="predictive-search__result-thumbnail-placeholder"></div>';
          }
          html += '<div class="predictive-search__result-details">';
          html += '<p class="predictive-search__result-title">' + escapeHtml(article.title) + '</p>';
          html += '</div>';
          html += '</a>';
          html += '</li>';
        });
        html += '</ul>';
        html += '</div>';
      }

      /* View all results link */
      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="predictive-search__view-all" data-predictive-search-link>';
      html += VIEW_ALL_TEXT;
      html += '</a>';

      resultsContainer.innerHTML = html;

      /* Cache result links for keyboard navigation */
      resultLinks = Array.prototype.slice.call(resultsContainer.querySelectorAll('[data-predictive-search-link]'));
      focusedIndex = -1;
    }

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str));
      return div.innerHTML;
    }

    function updateFocus() {
      resultLinks.forEach(function(link, i) {
        if (i === focusedIndex) {
          link.classList.add('predictive-search__result-link--focused');
          link.scrollIntoView({ block: 'nearest' });
        } else {
          link.classList.remove('predictive-search__result-link--focused');
        }
      });
    }

    /* Debounced search */
    var debouncedFetch = debounce(function() {
      var query = input.value.trim();
      currentQuery = query;
      if (query.length === 0) {
        hideResults();
        return;
      }
      fetchResults(query);
    }, 300);

    /* Input handler */
    input.addEventListener('input', function() {
      debouncedFetch();
    });

    /* Prevent form submit when Enter is pressed on a focused result */
    form.addEventListener('submit', function(e) {
      if (focusedIndex >= 0 && focusedIndex < resultLinks.length) {
        e.preventDefault();
        resultLinks[focusedIndex].click();
      }
    });

    /* Keyboard navigation */
    input.addEventListener('keydown', function(e) {
      if (resultLinks.length === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        focusedIndex = Math.min(focusedIndex + 1, resultLinks.length - 1);
        updateFocus();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        focusedIndex = Math.max(focusedIndex - 1, -1);
        updateFocus();
      } else if (e.key === 'Enter' && focusedIndex >= 0) {
        e.preventDefault();
        resultLinks[focusedIndex].click();
      }
    });

    /* Close button */
    closeBtn.addEventListener('click', function() {
      close();
    });

    /* Close on Escape */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && container.classList.contains('predictive-search--active')) {
        close();
      }
    });

    /* Close on backdrop click */
    backdrop.addEventListener('click', function() {
      close();
    });

    /* Listen for open event from header search button */
    document.addEventListener('predictive-search:open', function() {
      open();
    });

    /* Close when input is cleared */
    input.addEventListener('search', function() {
      if (input.value === '') {
        hideResults();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
  (function() {
    var section = document.querySelector('.product-hero');
    if (!section) return;

    /* Thumbnail click swaps main image */
    var thumbnails = section.querySelectorAll('[data-thumbnail]');
    var mainImage = section.querySelector('[data-main-image]');

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        if (!mainImage) return;

        var src = this.getAttribute('data-image-src');
        var alt = this.getAttribute('data-image-alt');

        mainImage.setAttribute('src', src);
        mainImage.setAttribute('alt', alt || '');

        thumbnails.forEach(function(t) {
          t.classList.remove('product-hero__thumbnail--active');
        });
        this.classList.add('product-hero__thumbnail--active');
      });
    });

    /* Variant data from JSON script tag */
    var variantDataEl = section.querySelector('[data-product-variants]');
    var variants = [];
    if (variantDataEl) {
      try {
        variants = JSON.parse(variantDataEl.textContent);
      } catch (e) {
        console.error('Failed to parse variant data:', e);
      }
    }

    /* Variant selector change */
    var variantSelect = section.querySelector('[data-variant-select]');
    var variantIdInput = section.querySelector('[data-variant-id]');
    var addToCartBtn = section.querySelector('[data-add-to-cart]');
    var priceContainer = section.querySelector('[data-product-price]');

    if (variantSelect) {
      variantSelect.addEventListener('change', function() {
        var selectedId = parseInt(this.value, 10);
        var selectedVariant = null;

        for (var i = 0; i < variants.length; i++) {
          if (variants[i].id === selectedId) {
            selectedVariant = variants[i];
            break;
          }
        }

        if (!selectedVariant) return;

        /* Update hidden variant ID input */
        if (variantIdInput) {
          variantIdInput.value = selectedVariant.id;
        }

        /* Update price display */
        if (priceContainer) {
          var priceHtml = '';
          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            priceHtml = '<div class="price">';
            priceHtml += '<s class="price__compare">' + formatMoney(selectedVariant.compare_at_price) + '</s>';
            priceHtml += '<span class="price__sale">' + formatMoney(selectedVariant.price) + '</span>';
            priceHtml += '</div>';
          } else {
            priceHtml = '<div class="price"><span class="price__regular">' + formatMoney(selectedVariant.price) + '</span></div>';
          }
          priceContainer.innerHTML = priceHtml;
        }

        /* Update availability */
        if (addToCartBtn) {
          if (selectedVariant.available) {
            addToCartBtn.disabled = false;
            addToCartBtn.textContent = addToCartBtn.getAttribute('data-add-text') || 'Add to cart';
          } else {
            addToCartBtn.disabled = true;
            addToCartBtn.textContent = addToCartBtn.getAttribute('data-sold-text') || 'Sold out';
          }
        }

        /* Update featured image if variant has one */
        if (selectedVariant.featured_image && mainImage) {
          mainImage.setAttribute('src', selectedVariant.featured_image.src);
          mainImage.setAttribute('alt', selectedVariant.featured_image.alt || '');
        }
      });
    }

    /* Simple money formatter (cents to dollars) */
    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return '$' + amount;
    }

    /* Quantity +/- buttons */
    var quantityInput = section.querySelector('[data-quantity-input]');
    var minusBtn = section.querySelector('[data-quantity-minus]');
    var plusBtn = section.querySelector('[data-quantity-plus]');

    if (minusBtn && quantityInput) {
      minusBtn.addEventListener('click', function() {
        var val = parseInt(quantityInput.value, 10) || 1;
        if (val > 1) {
          quantityInput.value = val - 1;
        }
      });
    }

    if (plusBtn && quantityInput) {
      plusBtn.addEventListener('click', function() {
        var val = parseInt(quantityInput.value, 10) || 1;
        quantityInput.value = val + 1;
      });
    }

    /* Add to Cart: intercept form submit */
    var form = section.querySelector('form[action*="/cart/add"]');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        if (addToCartBtn && addToCartBtn.disabled) return;

        var formData = new FormData(form);
        var body = {};
        formData.forEach(function(value, key) {
          body[key] = value;
        });

        /* Ensure quantity is a number */
        body.quantity = parseInt(body.quantity, 10) || 1;

        if (addToCartBtn) {
          addToCartBtn.disabled = true;
        }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(body.id, 10),
            quantity: body.quantity
          })
        })
          .then(function(response) {
            if (!response.ok) {
              return response.json().then(function(data) {
                throw new Error(data.description || 'Could not add to cart');
              });
            }
            return response.json();
          })
          .then(function() {
            /* Show "Added!" text briefly */
            if (addToCartBtn) {
              var originalText = addToCartBtn.textContent;
              addToCartBtn.textContent = addToCartBtn.getAttribute('data-added-text') || 'Added!';
              setTimeout(function() {
                addToCartBtn.textContent = originalText;
                addToCartBtn.disabled = false;
              }, 1500);
            }

            /* Dispatch cart-drawer:open event */
            document.dispatchEvent(new CustomEvent('cart-drawer:open'));
            document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          })
          .catch(function(err) {
            console.error('Add to cart error:', err);
            if (addToCartBtn) {
              addToCartBtn.disabled = false;
              var originalText = addToCartBtn.textContent;
              addToCartBtn.textContent = err.message || 'Error';
              setTimeout(function() {
                addToCartBtn.textContent = originalText;
              }, 2000);
            }
          });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  (function() {
    var container = document.querySelector('[data-related-products]');
    if (!container) return;

    var productId = container.getAttribute('data-product-id');
    var sectionId = container.getAttribute('data-section-id');
    var url = container.getAttribute('data-url');
    var limit = container.getAttribute('data-limit');

    if (!productId || !sectionId || !url) return;

    var requestUrl = url + '?section_id=' + sectionId + '&product_id=' + productId + '&limit=' + limit;

    fetch(requestUrl)
      .then(function(response) {
        if (!response.ok) throw new Error('Failed to fetch recommendations');
        return response.text();
      })
      .then(function(html) {
        var tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        var newContainer = tempDiv.querySelector('[data-related-products]');
        if (newContainer) {
          container.innerHTML = newContainer.innerHTML;
        }
      })
      .catch(function(err) {
        console.error('Related products error:', err);
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousels = document.querySelectorAll('[data-testimonials-carousel]');

    carousels.forEach(function(carousel) {
      const track = carousel.querySelector('[data-testimonials-track]');
      const prevBtn = carousel.querySelector('[data-testimonials-prev]');
      const nextBtn = carousel.querySelector('[data-testimonials-next]');
      const dotsContainer = carousel.closest('.testimonials__container').querySelector('[data-testimonials-dots]');
      const dots = dotsContainer ? dotsContainer.querySelectorAll('[data-testimonials-dot]') : [];
      const slides = track ? track.children : [];
      const slideCount = slides.length;

      if (slideCount === 0) return;

      let currentIndex = 0;
      let autoplayInterval = null;
      const autoplay = carousel.dataset.autoplay === 'true';
      const speed = (parseInt(carousel.dataset.speed, 10) || 5) * 1000;

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = slideCount - 1;
        } else if (index >= slideCount) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';

        dots.forEach(function(dot, i) {
          dot.classList.toggle('testimonials__dot--active', i === currentIndex);
        });
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function prevSlide() {
        goToSlide(currentIndex - 1);
      }

      function startAutoplay() {
        if (autoplay && slideCount > 1) {
          autoplayInterval = setInterval(nextSlide, speed);
        }
      }

      function stopAutoplay() {
        if (autoplayInterval) {
          clearInterval(autoplayInterval);
          autoplayInterval = null;
        }
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          stopAutoplay();
          nextSlide();
          startAutoplay();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          stopAutoplay();
          prevSlide();
          startAutoplay();
        });
      }

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          stopAutoplay();
          goToSlide(parseInt(dot.dataset.testimonialsDot, 10));
          startAutoplay();
        });
      });

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
